export default [
  { text: 'Comfort', icon: '$vuetify.icons.chicken', value: 'COMFORT' },
  { text: 'Healthy', icon: '$vuetify.icons.heart', value: 'HEALTHY' },
  { text: 'Worldly', icon: '$vuetify.icons.globe', value: 'WORLDLY' },
  { text: 'Green', icon: '$vuetify.icons.leaf', value: 'GREEN' },
  {
    text: 'Experimental',
    icon: '$vuetify.icons.flask',
    value: 'EXPERIMENTAL'
  }
]
